export const de = {
  "app.title": "survivrr.io",
  "menu.online": "Online",
  "menu.offline": "Offline",
  "menu.play": "Spielen",
  "menu.name": "Name",
  "menu.ballColor": "Ballfarbe",
  "menu.nameColor": "Namensfarbe",
  "menu.moreInfo": "Mehr Info",
  "menu.moreInfoTitle": "Mehr Info",
  "menu.moreInfoSubtitle": "Rechtliche Seiten, Cookie-Details und Kontaktinformationen.",
  "menu.back": "Zurück",
  "menu.privacySettings": "Datenschutzeinstellungen",
  "menu.cookiePolicy": "Cookie-Richtlinie",
  "menu.privacyPolicy": "Datenschutzrichtlinie",
  "menu.termsOfService": "Nutzungsbedingungen",
  "menu.emailButton": "E-Mail senden",
  "menu.websiteButton": "Meine Website ansehen",
  "menu.contactEmailLabel": "Kontakt-E-Mail:",
  "menu.emailLabel": "E-Mail:",
  "menu.websiteLabel": "Meine Website ansehen:",
  "menu.nameRequired": "Gib zuerst einen Namen ein.",
  "moreInfo.privacySettings.intro1": "Du kannst deine Datenschutzauswahl auf dieser Website über die Einwilligungsnachricht unseres Werbeanbieters verwalten, sofern sie verfügbar ist.",
  "moreInfo.privacySettings.intro2": "Du kannst Cookies und lokalen Speicher jederzeit auch in den Einstellungen deines Browsers steuern.",
  "moreInfo.privacySettings.adsHeading": "Werbeeinstellungen",
  "moreInfo.privacySettings.adsParagraph": "Einige Anzeigen können von Google oder anderen Partnern bereitgestellt werden. Einstellungen für personalisierte Werbung können auch direkt in den Google-Werbeeinstellungen verwaltet werden.",
  "moreInfo.privacySettings.adsBullet1": "Öffne die Google-Werbeeinstellungen unter myadcenter.google.com.",
  "moreInfo.privacySettings.adsBullet2": "Lösche Cookies oder Websitedaten, wenn du deine Einwilligungsauswahl zurücksetzen möchtest.",
  "moreInfo.privacySettings.adsBullet3": "Nutze die Datenschutzeinstellungen deines Browsers, um Cookies zu blockieren oder einzuschränken.",
  "moreInfo.privacySettings.localHeading": "Lokale Einstellungen",
  "moreInfo.privacySettings.localParagraph": "Dieses Spiel speichert grundlegende lokale Einstellungen wie deinen Spielernamen, Farben, Soundeinstellung und Sprache, damit die Website sie auf deinem Gerät speichern kann.",
  "moreInfo.cookiePolicy.intro1": "Diese Website verwendet Cookies und ähnliche Speichertechnologien, um das Spiel auszuführen, deine Einstellungen zu speichern und Werbung zu unterstützen.",
  "moreInfo.cookiePolicy.intro2": "Cookies können je nach deiner Einwilligung und den aktivierten Diensten auch für Messung, Betrugsprävention und Anzeigenpersonalisierung verwendet werden.",
  "moreInfo.cookiePolicy.typesHeading": "Arten von Cookies und Speicher, die wir verwenden können",
  "moreInfo.cookiePolicy.typeBullet1": "Essentieller Speicher, der für den Betrieb der Website erforderlich ist.",
  "moreInfo.cookiePolicy.typeBullet2": "Präferenzspeicher, um deinen Namen, Farben, Sprache und Soundeinstellung zu speichern.",
  "moreInfo.cookiePolicy.typeBullet3": "Werbe- oder Messcookies von Werbepartnern wie Google, wenn Anzeigen aktiviert sind.",
  "moreInfo.cookiePolicy.manageHeading": "Cookies verwalten",
  "moreInfo.cookiePolicy.manageParagraph": "Du kannst Cookies über die Einwilligungsnachricht der Website verwalten, sofern verfügbar, oder über deine Browsereinstellungen. Das Deaktivieren einiger Cookies kann Funktionen oder Anzeigen beeinträchtigen.",
  "moreInfo.privacyPolicy.intro1": "Diese Website ist ein Browsergame, das von Michał Kierzkowski betrieben wird. Wir versuchen, so wenige personenbezogene Daten wie möglich zu erfassen.",
  "moreInfo.privacyPolicy.intro2": "Zum Spielen ist kein Konto erforderlich. Das Spiel kann grundlegende lokale Einstellungen auf deinem Gerät speichern und Gameplay-Daten verarbeiten, die für Online-Spiele erforderlich sind.",
  "moreInfo.privacyPolicy.infoHeading": "Informationen, die wir verarbeiten können",
  "moreInfo.privacyPolicy.infoBullet1": "Dein gewählter Spielername und kosmetische Einstellungen.",
  "moreInfo.privacyPolicy.infoBullet2": "Grundlegende Sitzungsdaten, die für Multiplayer-Funktionen erforderlich sind.",
  "moreInfo.privacyPolicy.infoBullet3": "Geräte-, Browser- oder Werbedaten, die von Analyse- oder Werbepartnern erfasst werden, wenn solche Dienste aktiviert sind.",
  "moreInfo.privacyPolicy.useHeading": "Wie wir Informationen verwenden",
  "moreInfo.privacyPolicy.useBullet1": "Um das Spiel und Online-Räume zu betreiben.",
  "moreInfo.privacyPolicy.useBullet2": "Um deine Einstellungen auf deinem Gerät zu speichern.",
  "moreInfo.privacyPolicy.useBullet3": "Um Leistung, Sicherheit und Stabilität zu verbessern.",
  "moreInfo.privacyPolicy.useBullet4": "Um Anzeigen einzublenden, wenn Werbung aktiviert ist.",
  "moreInfo.privacyPolicy.contactHeading": "Kontakt",
  "moreInfo.privacyPolicy.contactParagraph1": "Bei Fragen zum Datenschutz kontaktiere: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "Website: michalkierzkowski.com",
  "moreInfo.terms.intro1": "Durch die Nutzung dieser Website stimmst du zu, das Spiel rechtmäßig und fair zu verwenden.",
  "moreInfo.terms.intro2": "Das Spiel wird wie besehen bereitgestellt und kann jederzeit geändert, unterbrochen oder entfernt werden.",
  "moreInfo.terms.rulesHeading": "Regeln",
  "moreInfo.terms.ruleBullet1": "Missbrauche keine Bugs, Cheats, Automatisierung oder Exploits.",
  "moreInfo.terms.ruleBullet2": "Versuche nicht, den Dienst oder andere Spieler zu schädigen.",
  "moreInfo.terms.ruleBullet3": "Verwende keine beleidigenden, rechtswidrigen oder irreführenden Namen oder Inhalte.",
  "moreInfo.terms.limitationHeading": "Haftungsbeschränkung",
  "moreInfo.terms.limitationParagraph": "Wir haften im gesetzlich zulässigen Umfang nicht für Verluste, Unterbrechungen oder Schäden, die aus der Nutzung der Website entstehen.",
  "moreInfo.terms.changesHeading": "Änderungen",
  "moreInfo.terms.changesParagraph": "Diese Bedingungen können künftig aktualisiert werden. Die weitere Nutzung der Website nach Updates bedeutet, dass du die aktualisierten Bedingungen akzeptierst.",
  "status.offline": "Offline-Spiel wird gestartet...",
  "status.connecting": "Verbindung zum Server...",
  "queue.title": "Warten auf einen Raum",
  "queue.menu": "Zurück zum Hauptmenü",
  "game.pressToMove": "Zum Bewegen irgendwo drücken",
  "game.touchToMove": "Zum Bewegen irgendwo tippen",
  "game.leaderboard": "Bestenliste",
  "game.hp": "LP",
  "game.level": "Level",
  "game.xp": "XP",
  "game.respawning": "Wiederbelebung...",
  "gameEnd.title": "Spielende",
  "gameEnd.winTitle": "Du hast gewonnen",
  "gameEnd.subtitle": "Das Spiel ist beendet. Spawne neu, um die nächste Runde zu starten, oder kehre zum Menü zurück.",
  "pause.title": "Spielmenü",
  "pause.resume": "Fortsetzen",
  "pause.menu": "Zurück zum Hauptmenü",
  "upgrade.title": "Wähle ein Upgrade",
  "upgrade.generic.title": "Upgrade",
  "upgrade.generic.description": "Verbessere deinen Build.",
  "upgrade.newWeaponPrefix": "Neue Waffe:",
  "upgrade.stat.maxHp.title": "Max. LP",
  "upgrade.stat.maxHp.description": "Erhöht die maximalen LP.",
  "upgrade.stat.speed.title": "Bewegungsgeschwindigkeit",
  "upgrade.stat.speed.description": "Erhöht die Bewegungsgeschwindigkeit.",
  "upgrade.stat.generic.title": "Stat-Upgrade",
  "upgrade.stat.generic.description": "Verbessere deine Werte.",
  "upgrade.weapon.projectileShot.title": "Projektilschuss",
  "upgrade.weapon.projectileShot.description": "Füge deinem Build Projektilschüsse hinzu.",
  "upgrade.weapon.orbitingBalls.title": "Orbitale Kugeln",
  "upgrade.weapon.orbitingBalls.description": "Füge deinem Build orbitale Kugeln hinzu.",
  "upgrade.weapon.damageZone.title": "Schadenszone",
  "upgrade.weapon.damageZone.description": "Fügt eine Schadenszone um deinen Charakter hinzu.",
  "upgrade.weapon.generic.title": "Waffe",
  "upgrade.weapon.generic.description": "Füge diese Waffe deinem Build hinzu.",
  "upgrade.weaponUpgrade.frequency.title": "Frequenz",
  "upgrade.weaponUpgrade.frequency.description": "Greife häufiger an.",
  "upgrade.weaponUpgrade.range.title": "Reichweite",
  "upgrade.weaponUpgrade.range.description": "Erhöht die Waffenreichweite.",
  "upgrade.weaponUpgrade.projectileCount.title": "Projektilanzahl",
  "upgrade.weaponUpgrade.projectileCount.description": "Erzeugt mehr Projektile.",
  "upgrade.weaponUpgrade.projectileSpeed.title": "Projektilgeschwindigkeit",
  "upgrade.weaponUpgrade.projectileSpeed.description": "Macht Projektilschüsse schneller.",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "Orbitale Geschwindigkeit",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "Lässt orbitale Kugeln schneller rotieren.",
  "upgrade.weaponUpgrade.damage.title": "Schaden",
  "upgrade.weaponUpgrade.damage.description": "Verursacht mehr Schaden.",
  "upgrade.weaponUpgrade.generic.title": "Waffen-Upgrade",
  "upgrade.weaponUpgrade.generic.description": "Verbessere diese Waffe.",
  "defeat.title": "Niederlage",
  "defeat.subtitle": "Respawne oder kehre zum Menü zurück",
  "defeat.respawn": "Respawn",
  "defeat.menu": "Hauptmenü",
  "error.generic": "Etwas ist schiefgelaufen.",
} as const;
